const activationKeys = ['Enter', ' ', 'Spacebar']

export const useKeyboardActivation = (handler: (event: KeyboardEvent) => void) => {
  return (event: KeyboardEvent) => {
    if (activationKeys.includes(event.key)) {
      event.preventDefault()
      handler(event)
    }
  }
}
